/* @flow */
import * as React from 'react';
import PjpMetricCard from './PjpMetricCard';
import { createPjpMetricCardContainer } from './createPjpMetricCardContainer';
import { deepPure } from 'common/utils/ReactUtils';

/* Deep comparison is required here because of 2 reasons:
    1. Brush in recharts resets when even when data reference changes.
    2. Since the data is composed from store,
    it would be different even when memoized (selectors are memoized with size of 1)
*/
type Props = React.ElementConfig<typeof PjpMetricCard>;

export default createPjpMetricCardContainer<Props>(deepPure(PjpMetricCard));
